import { useRef, useImperativeHandle } from 'react';

/**
 * Get a ref that can be used inside your component, but is also shared with the ref passed in
 * via props. This is useful when you want to expose a ref to a parent component, but also need
 * to use the ref internally.
 *
 * @example
 *
 * function MyComponent(props: { forwardedRef?: React.Ref<HTMLElement> }) {
 *   const ref = useSharedRef(props.forwardedRef)
 *
 *   useEffect(() => {
 *     ref.current.focus()
 *   }, [])
 *
 *   return <button ref={ref}>Click Here</button>
 * }
 */
function useSharedRef(otherRef) {
    const ref = useRef(null);
    useImperativeHandle(otherRef, () => ref.current, []);
    return ref;
}

export { useSharedRef };
//# sourceMappingURL=use-shared-ref.js.map
